var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisaCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 31,
    rx: 3.5,
    fill: "white",
    stroke: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3119 21.9467H18.1162L20.115 10.7461H23.3106L21.3119 21.9467Z",
    fill: "#15195A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8963 11.0198C32.266 10.7932 31.2662 10.543 30.03 10.543C26.8742 10.543 24.6518 12.0681 24.6382 14.2485C24.612 15.8572 26.2293 16.7508 27.439 17.2872C28.6753 17.8353 29.0956 18.193 29.0956 18.6816C29.083 19.432 28.0965 19.7778 27.1765 19.7778C25.9006 19.7778 25.217 19.5995 24.1781 19.1821L23.7573 19.0031L23.3101 21.5174C24.0596 21.8268 25.4405 22.1015 26.8742 22.1135C30.2273 22.1135 32.4103 20.612 32.4362 18.2884C32.449 17.0133 31.5949 16.0364 29.7537 15.238C28.636 14.7255 27.9515 14.38 27.9515 13.8556C27.9646 13.3789 28.5305 12.8906 29.7922 12.8906C30.8311 12.8667 31.5944 13.093 32.1727 13.3195L32.4617 13.4384L32.8963 11.0198Z",
    fill: "#15195A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6168 10.7461H41.0887L43.6668 21.9465H40.7079C40.7079 21.9465 40.4184 20.6596 40.3266 20.2664H36.2236C36.1049 20.5641 35.5529 21.9465 35.5529 21.9465H32.1997L36.9465 11.6754C37.2754 10.9485 37.8545 10.7461 38.6168 10.7461ZM38.4199 14.8449C38.4199 14.8449 37.4072 17.3352 37.1441 17.9787H39.8003C39.6689 17.4187 39.0637 14.7377 39.0637 14.7377L38.8404 13.7725C38.7463 14.0211 38.6103 14.3627 38.5186 14.5932C38.4564 14.7494 38.4146 14.8545 38.4199 14.8449Z",
    fill: "#15195A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2694 10.7461H9.41099C10.1079 10.7697 10.6734 10.9722 10.8574 11.6876L11.9747 16.8333C11.9749 16.8338 11.975 16.8343 11.9752 16.8348L12.3172 18.3838L15.4468 10.7461H18.826L13.8029 21.9348H10.4236L7.57524 12.2025C6.59246 11.6818 5.47084 11.263 4.2168 10.9724L4.2694 10.7461Z",
    fill: "#15195A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCard);
export default __webpack_public_path__ + "assets/20250729051354/media/visaCard.59cf1ac534ba965db3516fd698fd3b51.svg";
export { ForwardRef as ReactComponent };